export default {
  UPDATE: 'customers/update',
  UPDATE_TAGS: 'customers/update/tags',
  LIST: 'customers/list',
  LIST_NEXT: 'customers/list/next',
  FETCHING: 'customers/fetching',
  FULFILLED: 'customers/fulfilled',
  REJECTED: 'customers/rejected',
  CLEAR: 'customers/clear',
  DETAIL: 'customer/detail',
  DETAIL_FETCHING: 'customers/detail/fetching',
  DETAIL_FULFILLED: 'customers/detail/fulfilled',
  DETAIL_REJECTED: 'customers/detail/rejected',
  DETAIL_CLEAR: 'customers/detail/clear',
  LIST_EARNING: 'customers/earning/list',
  LIST_EARNING_NEXT: 'customers/earning/list/next',
  LIST_REDEMPTION: 'customers/redemption/list',
  LIST_REDEMPTION_NEXT: 'customers/redemption/list/next',
  LIST_COMMUNICATION: 'customers/communication/list',
  LIST_COMMUNICATION_NEXT: 'customers/communication/list/next',
  LIST_GIFT: 'customers/gift/list',
  LIST_GIFT_NEXT: 'customers/gift/list/next',
}
